/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Src_1_DetailInputs */

const en_wb_sales_src_1_detail = /** @type {(inputs: Wb_Sales_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email · Monday, 09:40`)
};

const lv_wb_sales_src_1_detail = /** @type {(inputs: Wb_Sales_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pasts · pirmdien, 09:40`)
};

/**
* | output |
* | --- |
* | "Email · Monday, 09:40" |
*
* @param {Wb_Sales_Src_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_src_1_detail = /** @type {((inputs?: Wb_Sales_Src_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Src_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_src_1_detail(inputs)
	return en_wb_sales_src_1_detail(inputs)
});